import { addUniquenotEmptyElements } from "../../helpers";
export class TopLeaguesRetriever {
    constructor(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.requestTopLeague = {};
        this.requestTopLeague.ids = [this.dataProvider.sportId];
        this.requestTopLeague.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId || []);
        this.loadedData = loadedData;
    }
    setRegionIds(regionId) {
        this.requestTopLeague.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId.concat(regionId));
    }
    removeRegionId() {
        this.requestTopLeague.regionIds = [this.dataProvider.regionId[0]];
    }
    loadData() {
        this.bff.getTopLeaguesBySportId(this.requestTopLeague)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err); });
    }
    loadDataSuccessCb(response) {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}
//# sourceMappingURL=TopLeaguesRetriever.js.map